controllers.controller('Step2RegistrationController', [
    '$scope', '$state', '$ionicLoading', '$q', '$timeout', '$location', '$rootScope', '$ionicHistory', '$ionicScrollDelegate', '$ionicModal', '$document',
    'config', 'constants', 'ErrorService', 'API', 'LocaleService', 'LoginService', 'countries',
    'Storage', 'BlueprintRegistration', 'UserService', 'LocalStorage', 'moment', 'appsflyer',
    function ($scope, $state, $ionicLoading, $q, $timeout, $location, $rootScope, $ionicHistory, $ionicScrollDelegate, $ionicModal, $document,
              config, Const, ErrorService, API, LocaleService, LoginService,
              Countries, Storage, Blueprint, UserService, LocalStorage, moment, appsflyer) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.constants = Const;
        $scope.countries = Countries.countryCode;
        $scope.search = {};

        $scope.validator = {
            // alpha: '[^[0-9\]\'\.\?\~\`\!\@\#\$\%\^\&\*\_\+\=\{\}\()/><\][\\\x22,;|]+',
            // alpha: /\b[^\d\W]+\b/,
            alpha: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
            email: '[a-zA-Z0-9-+_\\@\\.]+',
            phone: '^[0-9]{1,}$',
            mix: /^[a-zA-Z0-9]+$/,
            birthday: /^\d{2}[./-]\d{2}[./-]\d{4}$/,
            address: '[^\\\'\\?\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\_\\+\\=\\{\\}/><\\][\\\\\x22;|]+',
            city: '[^[0-9\\]\\\'\\?\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\_\\+\\=\\{\\}\\()/><\\][\\\\\x22;|]+',
            number: '[a-zA-Z0-9-\\.]+'
        };

        $scope.signupForm = {};
        var registrationCache = Storage.get('registration');
        if (registrationCache) {
            $scope.signupForm = registrationCache;

            //set country and nationality from cache
            $scope.countryName = _.find($scope.countries, {code: $scope.signupForm.country}).country;
            $scope.nationalityName = $scope.signupForm.citizenship;
        }

        $scope.minBirth =  moment().utc().subtract(18, 'y').format("YYYY-MM-DD");

        $scope.navigate = function (state, params) {
            $state.go(state, params);
        };

        $scope.password = {
            checked: false
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false,
            back: 'root.app.assets'
        };

        function wait(data) {
            return $timeout(function () {
                return data;
            }, 1000)
        }

        $scope.birthCountry = function (code) {
            if ($scope.signupForm.isBirthCountry) {
                var country = _.find($scope.countries, {code: code});
                if (country) {
                    $scope.signupForm.citizenship = country.nationality;
                    $scope.nationalityName = country.nationality;
                    $scope.FormController && $scope.FormController.citizenship.$setDirty();
                    $scope.signupForm.birthCountry = $scope.signupForm.country;
                }
            }
        };

        $scope.goNextPage = function (state, form) {
            if (form) {
                validateForm(form);
                $timeout(function () {
                    //find first invalid field and jump to it
                    var invalidField = $document[0].getElementById('createAccount').getElementsByClassName('has-error')[0];
                    if (invalidField) {
                        $location.hash(invalidField.id);
                        return $ionicScrollDelegate.anchorScroll();
                    }

                    Storage.set('registration', angular.copy($scope.signupForm));
                    $state.go(state, {cache: false});
                }, 0)
            }
        };

        function validateForm(form) {
            //set all fields as dirty to turn on its validations
            Object.keys(form)
                .filter(function (key) {
                    return !key.match(/^\$/)
                })
                .forEach(function (key) {
                    form[key].$setDirty();
                    form[key].$validate();
                });
        }

        $scope.scrollTo = function ($event, nextEl) {
            if (Storage.get('platform') === 'android') {
                return $timeout(function () {
                    $location.hash(nextEl);
                    return $ionicScrollDelegate.anchorScroll();
                }, 500);
            }
        };

        $scope.countriesModal = function (type, form) {
            $ionicModal.fromTemplateUrl('templates/countries-select.html', {
                scope: $scope,
                hardwareBackButtonClose: false,
                animation: 'slide-in-up'
            }).then(function (modal) {
                $scope.selectType = type;
                $scope.countryModal = modal;
                $scope.countryModal.show();
                $scope.FormController = form;
            });
        };

        $scope.setCountry = function (country) {
            if ($scope.selectType === 'country') {
                $scope.signupForm.country = country.code;
                $scope.countryName = country.country;
                $scope.FormController.country.$setDirty();
            }

            if ($scope.selectType === 'nationality') {
                $scope.signupForm.citizenship = country.nationality;
                $scope.nationalityName = country.nationality;
                $scope.FormController.citizenship.$setDirty();
            }

            $scope.search = {};
            $scope.countryModal.hide();
        };

        $scope.closeCountryModal = function () {
            $scope.countryModal && $scope.countryModal.hide();
        };

        $scope.$on('registration', doRegistration);

        function doRegistration(event, questions) {
            var user = UserService.get();
            if (!questions) return;

            var registration = angular.merge(
                Blueprint.create('long')(Storage.get('registration')),
                questions);

            function checkRegistration(data) {
                if (data.Code != "1") {
                    throw new ErrorService({
                        source: 'Step2RegistrationController',
                        type: Const.error.type.VALIDATION,
                        code: data.Description || 'registrationFailed',
                        severity: 'warning',
                        data: {request: registration, response: data}
                    });
                }
                return data;
            }

            function updateCustomerData(data) {
                $scope.loadingMessage = LocaleService.translation.logging_in;
                return API.getCustomerData()
                    .then(function (userData) {
                        appsflyer.trackEvent("finish_registration", {user: userData.data.Email});

                        user.onLogin(userData);
                        return {
                            login: data.MT4Login,
                            source: data.isReal ? Const.system.loginSources[1].id : Const.system.loginSources[0].id
                        }
                    })
            }

            function tradeLogin(data) {
                return LoginService.mt4Login(data.login, data.source)
                    .then(LoginService.mt4ClearServices)
                    .then(LoginService.mt4InitServices)
                    .then(function () {
                        return data;
                    })
            }

            function setActiveAccount(data) {
                LocalStorage.set('activeAccount', JSON.stringify({login: data.login, source: data.source}));

                $rootScope.$broadcast('init');

                $ionicHistory.clearHistory();

                $ionicLoading.hide();

                $state.go('root.app.assets', {cache: false});
            }

            function resetForm (data){
                Storage.remove('registration');
                return data;
            }

            $scope.loadingMessage = LocaleService.translation.updateCustomer;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            API.updateCustomer({params: registration})
                .then(checkRegistration)
                .then(resetForm)
                .then(updateCustomerData)
                .then(tradeLogin)
                .then(setActiveAccount)
                .catch(function (error) {
                    $ionicLoading.hide();
                    //failed registration
                    $scope.modal.isError = true;
                    $scope.modal.isProcess = false;
                    $scope.modal.textTitle = error && LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.textContent = error.code && error.code.match(/^Err6\d\d$/) ? LocaleService.translation.messages.general_error_text : '';
                    $scope.modal.state = true;
                });
        }

        $scope.$on('$ionicView.afterLeave', function (event) {
            $scope.countryModal && $scope.countryModal.hide() && $scope.countryModal.remove();
        });
    }]);
